import * as cons from './constants';
import * as apis from './apis';
import { requestActionMaker } from '../helper';

export const getAllApplication = para => requestActionMaker({ cons: cons.GET_ALL_APPLICATION, api: apis.getAllApplication, ...para });
export const getApplication = para => requestActionMaker({ cons: cons.GET_APPLICATION, api: apis.getApplication, ...para });
export const createApplication = para => requestActionMaker({ cons: cons.CREATE_APPLICATION, api: apis.createApplication, ...para });